// Build-time injected metadata. Vite's `define` config replaces these
// identifiers literally at build time:
//   __APP_VERSION__ → short git SHA (or "dev")
//   __BUILD_TIME__  → ISO timestamp of the Vite build
//
// `typeof` checks shield the test environment (Vitest doesn't run
// through the Vite build step, so the defines aren't injected and the
// identifiers are `undefined`).

declare const __APP_VERSION__: string | undefined;
declare const __BUILD_TIME__: string | undefined;

export const APP_VERSION: string =
  typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "dev";

export const BUILD_TIME: string =
  typeof __BUILD_TIME__ !== "undefined" ? __BUILD_TIME__ : "unknown";

/** Human-friendly one-liner like "v6dcc0b8 · 2026-05-15". For the
 *  footer chip / About panel / status surfaces. */
export function versionLabel(): string {
  if (BUILD_TIME === "unknown") return `v${APP_VERSION}`;
  const ymd = BUILD_TIME.slice(0, 10);
  return `v${APP_VERSION} · ${ymd}`;
}
